import { useMemo } from 'react'
// @ts-ignore
import countryList from 'react-select-country-list'
import { useTranslation } from 'react-i18next'

export const useKycData = () => {
  const { t } = useTranslation()
  const countryLists = useMemo(() => {
    const data = countryList().getData()
    return data
  }, [])

  const identificationTypes = useMemo(() => [
    { value: 'id_card', label: t('身份证') },
    { value: 'passport', label: t('护照') },
  ], [])

  return {
    countryLists,
    identificationTypes
  }
}